export default __webpack_public_path__ + "maps-examples-style-circles-categorically-1200-46a80c6c866048ba346e510c26e9f646.png";